export default "__VITE_ASSET__C8efvDBQ__"